module.exports = __webpack_public_path__ + "OpenSans-Light.0e81d518fab72ed76dce.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-Light.ttf
// module id = ../../../../../src/assets/customfonts/OpenSans-Light.ttf
// module chunks = styles